import { createStore, createEvent } from "effector";
import { PAGES, TotemWashingStoreState } from "./WashingStore.types";
import { washingStoreInteraction, washingStoreState } from "./WashingStore.consts";
import { fetchWashingMachinesEffect } from "./WashingStore.effects";
import { PaymentOption, WashingOption } from "../../types/washing.types";

// Eventos (ações)
export const setPage = createEvent<PAGES>('setPage');
export const setLicencePlate = createEvent<string>('setLicencePlate');
export const setTaxId = createEvent<string>('setTaxId');
export const setSelectedWashing = createEvent<WashingOption>('setSelectedWashing');
export const setSelectedPayment = createEvent<PaymentOption>('setSelectedPayment');
export const setFinalPrice = createEvent<number>('setFinalPrice');
export const setTotemId = createEvent<string>('setTotemId');
export const setTerminalId = createEvent<string>('setTerminalId');
export const setPaymentId = createEvent<string>('setPaymentId');
export const setCieloTransactionId = createEvent<string>('setCieloTransactionId');
export const setErrorMsg = createEvent<string>('setErrorMsg');
export const restartInteraction = createEvent('restartInteraction');
export const resetWashingStore = createEvent();

// Store inicial
export const WashingStore = createStore<TotemWashingStoreState>(washingStoreState)
  .on(setPage, (store, page) => ({
    ...store,
    currPage: page
  }))
  .on(setSelectedWashing, (store, selectedWashing) => ({
    ...store,
    selectedWashing
  }))
  .on(setSelectedPayment, (store, selectedPayment) => ({
    ...store,
    selectedPayment
  }))
  .on(setFinalPrice, (store, finalPrice) => ({
    ...store,
    finalPrice
  }))
  .on(setTotemId, (store, totemId) => ({
    ...store,
    totemId
  }))
  .on(setTerminalId, (store, terminalId) => ({
    ...store,
    terminalId
  }))
  .on(setPaymentId, (store, paymentId) => ({
    ...store,
    paymentId
  }))
  .on(setCieloTransactionId, (store, cieloTransactionId) => ({
    ...store,
    cieloTransactionId
  }))
  .on(setErrorMsg, (store, errorMsg) => ({
    ...store,
    errorMsg
  }))
  .on(setLicencePlate, (store, licencePlate) => ({
    ...store,
    licencePlate
  }))
  .on(setTaxId, (store, taxId) => ({
    ...store,
    taxId
  }))
  .on(fetchWashingMachinesEffect.doneData, (store, washingOptions) => {
    const availableWashings = washingOptions;
    if(!availableWashings.length) {
      availableWashings.push({} as WashingOption)
    }
    return ({
      ...store,
      washingOptions,
      selectedWashing: availableWashings[0]
    })
  })
  .on(restartInteraction, (store) => ({
    ...store,
    ...washingStoreInteraction
  }))
  .reset(resetWashingStore);
